module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "credit"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PICTURE CREDITS")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg6"
    }
  }, [_vm._v("Maison de Nostradamus, Salon-de-Provence")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#pg18"
    }
  }, [_vm._v("Faculty of Medicine, Montpellier")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#pg26"
    }
  }, [_vm._v("Musée Condé, Chantilly")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#pg96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Musée du Louvre/Réunion des Musées Nationaux")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#pg157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Musée du Louvre/Réunion des Musées Nationaux")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#pg122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliothèque Nationale, Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#pg134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliothèque Nationale, Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#pg181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliothèque Nationale, Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#pg153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliothèque Ste-Geneviève, Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#pg159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliothèque du Conservatoire des Arts et Métiers")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#pg198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("National Portrait Gallery, London")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#pg208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kunsthistorisches Museum, Vienna")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#pg212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kungl. Biblioteket, the Royal Library, Stockholm")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#pg215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kungl. Biblioteket, the Royal Library, Stockholm")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#pg256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albertina Collection, Vienna")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg3b"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg3c"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg5"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg9"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#pg11"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#pg32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#pg50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#pg56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#pg70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#pg81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson (courtesy of the Bibliothèque Municipale, Albi)")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#pg91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#pg110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#pg112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#pg194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#pg221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#pg237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson (courtesy of the Bibliothèque Municipale, Albi)")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#pg241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#pg242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#pg263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#pg270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#pg273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#pg287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judith Wilson")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5184faba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/credit.vue
// module id = 69
// module chunks = 0